import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const MIRAMARLIFTSTATIONS_LAYER_ID = 'miramarLiftStationsLayer';

const layerConfig = {
  title: 'Lift Stations',
};

function MiramarLiftStationsLayer() {
  const dispatch = useDispatch();
  const { miramarLiftStationsLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarLiftStationsLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarLiftStationsLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARLIFTSTATIONS_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarLiftStationsLayer.visible,
      opacity: miramarLiftStationsLayer.opacity,

      getFillColor: [199, 126, 52],
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARLIFTSTATIONS_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Lift Station Details',
              includeColumns: [
                'Lift_Station_ID',
                'Pump_Information',
                'Year_Built',
                'Rim_Elevation',
                'Off_Level_Difference',
                'Primary_On_Level_Difference',
              ],
            }),
          };
        }
      },
    });
  }
}

export default MiramarLiftStationsLayer;
